import * as React from 'react';
import MuiListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { TypographyProps } from '@mui/material/Typography';
import { CommonPropsAndTypes } from '../../_Types/StandardComponentProps';

interface IProps extends CommonPropsAndTypes.ITypographyProps {
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
  style?: any;
  className?: string;
  primaryTypographyProps?: TypographyProps<'span', { component?: 'span' }>;
  noLeftPadding?: boolean;
  denseLeftPadding?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
  noLeftPadding: {
    paddingLeft: theme.spacing(0),
  },
  denseLeftPadding: {
    paddingLeft: theme.spacing(0.5),
  },
  primary: {
    fontSize: theme.typography.pxToRem(13), // FIXME: varför använder vi 13px? varför inte 12 eller 14?
  },
  noLineBreak: { whiteSpace: 'nowrap' },
  bold: { fontWeight: 500 },
  bolder: { fontWeight: 600 },
});

const EDListItemText: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    classes,
    noLineBreak,
    bold,
    bolder,
    noLeftPadding,
    denseLeftPadding,
    primaryTypographyProps,
    ...other
  } = props;

  const classOverrides = {
    root: classNames(classes.root, classes.verticalMargin, {
      [classes.noLeftPadding]: noLeftPadding,
      [classes.denseLeftPadding]: denseLeftPadding,
    }),
    primary: classNames(classes.primary, {
      [classes.noLineBreak]: noLineBreak,
      [classes.bold]: bold && !bolder,
      [classes.bolder]: bolder,
    }),
  };

  return (
    <MuiListItemText
      classes={classOverrides}
      primaryTypographyProps={props.primaryTypographyProps}
      {...other}
    />
  );
};

export default withStyles(EDListItemText, styles);
